let locales = {
    announcementNoteDetail_detail: `Dettaglio`,
}

export default locales;